import { useCallback, useEffect, useMemo } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { IFlexItem } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'
import { IVisibilityWidgetSettings } from 'core-components/sitebuilder/models/flexGrid/ISystemWidgetSettings'
import { SizeSelector } from 'core-components/sitebuilder/settings/detail/basicSettings/SizeSelector'
import styles from 'core-components/sitebuilder/settings/detail/customSettings/SettingsCommonStyles.module.scss'
import { VisibilitySettings } from 'core-components/sitebuilder/settings/detail/customSettings/VisibilitySettings'

export interface IEditButtonContent {
  item: IFlexItem
  onChange: (newValue: IFlexItem) => void
}

export const EditButtonContent = ({ item, onChange }: IEditButtonContent) => {
  const visibilitySettings = useMemo(() => {
    return item.visibilitySettings || {}
  }, [item.visibilitySettings])

  const changeValueHandler = useCallback(
    (field: keyof IFlexItem, value: unknown) => {
      onChange({ ...item, [field]: value })
    },
    [item, onChange]
  )

  const visibilityChangeHandler = useCallback(
    (newData: Partial<IVisibilityWidgetSettings>) => {
      const newVisibleSettings = { ...visibilitySettings, ...newData }
      changeValueHandler('visibilitySettings', newVisibleSettings)
    },
    [visibilitySettings]
  )

  useEffect(() => {
    if (item.canWrap === undefined) {
      changeValueHandler('canWrap', true)
    }
  }, [])

  return (
    <div>
      <div className={styles.header}>Spacing: </div>
      <div className={styles.line}>
        <SizeSelector
          value={`${item.gap}`}
          onChange={(newSize) => {
            changeValueHandler('gap', newSize ? parseInt(newSize, 10) : 0)
          }}
          label={'gap'}
        />

        <SizeSelector
          value={`${item.margin}`}
          onChange={(newSize) => {
            changeValueHandler('margin', newSize ? parseInt(newSize, 10) : 0)
          }}
          label={'margins'}
        />

        <Checkbox
          checked={item.canWrap}
          onChange={(newValue) => {
            changeValueHandler('canWrap', newValue)
          }}
          label={'Allow line break'}
        />
      </div>
      <VisibilitySettings
        settings={{
          showWhen: visibilitySettings.showWhen,
          hideWhen: visibilitySettings.hideWhen,
          showWhenValue: visibilitySettings.showWhenValue,
          hideWhenValue: visibilitySettings.hideWhenValue,
        }}
        onChange={visibilityChangeHandler}
      />
    </div>
  )
}
